import qs from 'query-string'
import { paths } from '@/constants/paths'

export interface BuildLoginUrlOptions {
  returnTo: string
  email?: string
}

export const buildLoginUrl = (returnToOrOptions: string | BuildLoginUrlOptions): string => {
  const options: BuildLoginUrlOptions =
    typeof returnToOrOptions === 'string' ? { returnTo: returnToOrOptions } : returnToOrOptions

  const hashed = Buffer.from(options.returnTo, 'utf-8').toString('base64')

  const queryParams: Record<string, string> = {
    returnTo: hashed,
  }

  if (options.email) {
    queryParams.email = options.email
  }

  // Use query-string library to match server-side encoding behavior
  return `${paths.auth.login}?${qs.stringify(queryParams)}`
}

export const buildLogoutUrl = (returnTo?: string): string => {
  if (returnTo) {
    const hashed = Buffer.from(returnTo, 'utf-8').toString('base64')
    return `${paths.auth.logout}?${qs.stringify({ returnTo: hashed })}`
  } else {
    return paths.auth.logout
  }
}
